import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Home';
import Demo from './components/Demo';
import Admin from './admin/Admin';

import Layout from './components/common/Layout';
import TextChat from './components/chat/TextChat';
import VoiceChat from './components/chat/VoiceChat';
import Settings from './components/Settings';
import SupportPage from './components/Support.js';
import ChatSessionViewer from './components/CallHistoryViewer';
import KnowledgeBasePage from './components/KnowledgeBasePage';

const App = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'knowledge-base':
        return <KnowledgeBasePage />;
      case 'test-text-chat':
        return <TextChat />;
      case 'test-voice-chat':
        return <VoiceChat />;
      case 'settings':
        return <Settings />;
      case 'history':
        return <ChatSessionViewer />;
      case 'support':
        return <SupportPage />;
      default:
        // return <PlaceholderContent title={activeTab} />;
    }
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Root route - shows the layout with tab content */}
        <Route 
          path="/" 
          element={
            <Layout activeTab={activeTab} setActiveTab={setActiveTab}>
              {renderTabContent()}
            </Layout>
          } 
        />
        
        <Route path="/login" element={<Login />}/>
        <Route path="/demowebsite" element={<Demo />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
